import { memo } from 'react';
import { dLog } from '@/_helpers/renderDebug';

const About = ({ show, logo, description, rtl, toggleAboutPopup, socials }: any) => {
  if (!show) return null;
  dLog('About');
  return (
    <div className={`popup-about ${rtl ? 'rtl' : ''}`} id="about-pop">
      <div className="close" onClick={toggleAboutPopup} role="button" tabIndex={0}>
        <i className="fas fa-times" />
      </div>
      {logo && (
        <div className="about-logo">
          <img src={logo} alt="popup-logo" />
        </div>
      )}
      {/* eslint-disable-next-line react/no-danger */}
      {description && <div className="about-title" dangerouslySetInnerHTML={description} />}
      <div className="about-social-icons">
        {socials.facebook && (
          <a href={socials.facebook} target="_blank" rel="noreferrer">
            <i className="fab fa-facebook-f" />
          </a>
        )}
        {socials.twitter && (
          <a href={socials.twitter} target="_blank" rel="noreferrer">
            <i className="fa-brands fa-x-twitter" />
          </a>
        )}
        {socials.linkedin && (
          <a href={socials.linkedin} target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin-in" />
          </a>
        )}
        {socials.instagram && (
          <a href={socials.instagram} target="_blank" rel="noreferrer">
            <i className="fab fa-instagram" />
          </a>
        )}
      </div>
    </div>
  );
};

export default memo(About);
